<template>
  <div class="button">
    <v-btn v-bind="$props"
           :disabled="disabled"
           @click="handleClick"
           :style="styles"
    >
      <slot></slot>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: {
    block: Boolean,
    color: String,
    dark: Boolean,
    disabled: Boolean,
    icon: Boolean,
    height: [Number, String],
    maxHeight: [String, Number],
    maxWidth: [String, Number],
    outlined: Boolean,
    small: Boolean,
    styles: Object,
    tile: Boolean,
    width: [String, Number],
    xSmall: Boolean,
    stop: Boolean
  },
  methods: {
    handleClick (e) {
      if (this.disabled) return
      if (this.stop) e.stopPropagation()
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    &[btn-bg="dark-green"] {
      .v-btn {
        background-color: $dark-green;
      }
    }
    &[btn-bg="dark-red"] {
      .v-btn {
        background-color: $error-input-text-color;
      }
    }
    &[btn-bg="white"] {
      .v-btn {
        background-color: $white;
      }
    }
    &[btn-bg="blue-light"] {
      .v-btn {
        background-color: $blue-light;
      }
    }
    .v-btn {
      border-radius: 16px;
      text-transform: unset !important;
      box-shadow: unset !important;
    }
  }
</style>
